import * as React from 'react';
import { VersionTypeWrapper, WordWrapper } from './VersionType_SC';
import { XIIcon, GenericModal, BasicTile } from '@inmoment/the-kitchen';
import { NewUpdate } from '../../../../../AppUtils';
export interface Props {
  type: string;
  list: any;
  isBreaking?: boolean;
}

interface BreakingGroups {
  icons: string[];
}
export const VersionType: React.FC<Props> = (props) => {
  const { type, list, isBreaking = false } = props;

  const [showBreakingIcons, setShowBreakingIcons] = React.useState(false);

  const breakingGroup: BreakingGroups = {
    icons: [],
  };

  const mapped = (list as any[]).map((item: any, i) => {
    // to accommodate for the old and new updates
    let hasTitle = !!item.title;
    return (
      <WordWrapper key={item?.title ?? i}>
        <XIIcon style={{ minWidth: 24 }} icon="check" iconSize={24} />
        &nbsp;
        {hasTitle ? NewUpdate(item) : <p className="orca">{item}</p>}
      </WordWrapper>
    );
  });

  return (
    <VersionTypeWrapper>
      {isBreaking ? (
        <GenericModal isVisible={showBreakingIcons} onClose={() => setShowBreakingIcons((v) => !v)}>
          <BasicTile
            isInteractive={false}
            style={{
              display: 'flex',
              flexDirection: 'column',
              cursor: 'auto',
              overflow: 'scroll',
            }}
          >
            {breakingGroup.icons.map((icon) => (
              <WordWrapper>
                <XIIcon style={{ minWidth: 24 }} icon="check" iconSize={24} />
                &nbsp;
                <p className="orca">{icon.replace('_Icon', '')}</p>
              </WordWrapper>
            ))}
          </BasicTile>
        </GenericModal>
      ) : null}
      <p className="orca kxi-text-600">{type}:</p>
      {mapped}
    </VersionTypeWrapper>
  );
};
